import {
  GET_EVENTS,
  GET_EVENTS_SUCCESS,
  GET_EVENTS_FAILED,
  RESET_EVENTS,
  SHOW_LOADING_INDICATOR,
  HIDE_LOADING_INDICATOR,
  CHANGE_EVENT_PUBLISH_FIELD,
  CHANGE_EVENT_PUBLISH_FIELD_SUCCESS,
  CHANGE_EVENT_PUBLISH_FIELD_FAILED,
  SELECT_SINGLE_EVENT,
  SELECT_ALL_EVENTS,
  UPDATE_CATEGORIZED_EVENT_ORDER,
  UPDATE_CATEGORIZED_EVENT_ORDER_SUCCESS,
  UPDATE_CATEGORIZED_EVENT_ORDER_FAILED,
  RESET_EVENTS_SELECTION,
  SET_EVENTS_SORT_OPTIONS,
  UPDATE_EVENT_ORDER,
  UPDATE_EVENT_ORDER_SUCCESS,
  UPDATE_EVENT_ORDER_FAILED,
  OPEN_PUBLISH_NOTIFICATION_MODAL,
  HIDE_PUBLISH_NOTIFICATION_MODAL,
  HIDE_DELETE_EVENT_MODAL,
  OPEN_DELETE_EVENT_MODAL,
  HANDLE_DELETE_EVENT,
  HANDLE_DELETE_EVENT_SUCCESS,
  HANDLE_DELETE_EVENT_FAILED,
  OPEN_EVENT_BULK_DELETE_MODAL,
  HIDE_EVENT_BULK_DELETE_MODAL,
  HANDLE_EVENT_BULK_DELETE,
  HANDLE_EVENT_BULK_DELETE_SUCCESS,
  HANDLE_EVENT_BULK_DELETE_FAILED,
  ADD_NEW_EXPERIENCE,
  ADD_NEW_EXPERIENCE_SUCCESS,
  ADD_NEW_EXPERIENCE_FAILED,
  GET_SELECTED_EVENT,
  GET_SELECTED_EVENT_SUCCESS,
  GET_SELECTED_EVENT_FAILED,
  RESET_SELECTED_EVENT,
  GET_EVENT_INVITE_LIST,
  GET_EVENT_INVITE_LIST_SUCCESS,
  GET_EVENT_INVITE_LIST_FAILED,
  SEND_INVITES,
  SEND_INVITES_SUCCESS,
  SEND_INVITES_FAILED,
  RESET_EVENT_INVITE_LIST,
  DELETE_INVITE,
  DELETE_INVITE_SUCCESS,
  DELETE_INVITE_FAILED,
  ADD_ACCESS_CODE,
  ADD_ACCESS_CODE_FAILED,
  POST_IMAGE_ACCESS_CODE,
  ADD_ACCESS_CODE_SUCCESS,
  ADD_ACCESS_TAG,
  OPEN_SAVING_MODAL,
  HIDE_SAVING_MODAL,
  SET_EVENT_INVITE_LIST_SORT_OPTIONS,
  EDIT_ATTENDEE,
  EDIT_ATTENDEE_SUCCESS,
  EDIT_ATTENDEE_FAILED,
  ADD_ACCESS_TAG_SUCCESS,
  ADD_ACCESS_TAG_FAILED,
  SEND_APP_INVITES,
  SEND_APP_INVITES_SUCCESS,
  SEND_APP_INVITES_FAILED,
  UPDATE_RSVP,
  UPDATE_RSVP_SUCCESS,
  UPDATE_RSVP_FAILED,
  OPEN_INACTIVE_EVENT_WARNING_MODAL,
  HIDE_INACTIVE_EVENT_WARNING_MODAL,
  EDIT_ATTENDEE_AND_RSVP,
  EDIT_ATTENDEE_AND_RSVP_SUCCESS,
  EDIT_ATTENDEE_AND_RSVP_FAILED,
  DELETE_RSVP,
  DELETE_RSVP_SUCCESS,
  DELETE_RSVP_FAILED,
  UPDATE_EVENT_ACCESS_TYPE,
  UPDATE_EVENT_ACCESS_TYPE_SUCCESS,
  UPDATE_EVENT_ACCESS_TYPE_FAILED,
  GET_EVENT_MENU_LIST,
  GET_EVENT_MENU_LIST_SUCCESS,
  GET_EVENT_MENU_LIST_FAILED,
  UPDATE_EVENT_MENU_FEATURES_ORDER,
  UPDATE_EVENT_MENU_FEATURES_ORDER_SUCCESS,
  UPDATE_EVENT_MENU_FEATURES_ORDER_FAILED,
  UPDATE_EXPERIENCE,
  UPDATE_EXPERIENCE_SUCCESS,
  UPDATE_EXPERIENCE_FAILED,
  GET_EVENT_ACCESS_CODES,
  GET_EVENT_ACCESS_CODES_SUCCESS,
  GET_EVENT_ACCESS_CODES_FAILED,
  GET_INITIAL_ACCESS_TAGS,
  GET_INITIAL_ACCESS_TAGS_SUCCESS,
  GET_INITIAL_ACCESS_TAGS_FAILED,
  JOIN_EVENT,
  JOIN_EVENT_SUCCESS,
  JOIN_EVENT_FAILED,
  ASSIGN_EVENT_TO_CATEGORY,
  GET_EVENT_CATEGORIES,
  GET_EVENT_CATEGORIES_SUCCESS,
  GET_EVENT_CATEGORIES_FAILED,
  GET_EVENT_CODES,
  GET_EVENT_CODES_SUCCESS,
  GET_EVENT_CODES_FAILED,
  UPDATE_BULK_PUBLISH_STATUS,
  UPDATE_BULK_PUBLISH_STATUS_SUCCESS,
  UPDATE_BULK_PUBLISH_STATUS_FAILED,
  OPEN_EXPERIENCES_ERROR_MODAL,
  HIDE_EXPERIENCES_ERROR_MODAL,
  SEND_EMAIL_INVITE,
  SEND_EMAIL_INVITE_SUCCESS,
  SEND_EMAIL_INVITE_FAILED,
  GET_EVENT_DEEPLINK_URL,
  GET_EVENT_DEEPLINK_URL_SUCCESS,
  GET_EVENT_DEEPLINK_URL_FAILED,
  GET_EVENT_DEEPLINK_CODES,
  GET_EVENT_DEEPLINK_CODES_SUCCESS,
  GET_EVENT_DEEPLINK_CODES_FAILED,
  GENERATE_DEEPLINK_CODES,
  GENERATE_DEEPLINK_CODES_SUCCESS,
  GENERATE_DEEPLINK_CODES_FAILED,
  OPEN_GENERATE_DEEPLINK_MODAL,
  HIDE_GENERATE_DEEPLINK_MODAL,
  OPEN_EXP_CLONE_CONFIRMATION_MODAL,
  HIDE_EXP_CLONE_CONFIRMATION_MODAL,
  CLONE_EXPERIENCE,
  CLONE_EXPERIENCE_SUCCESS,
  CLONE_EXPERIENCE_FAILED,
} from "store/experiences/actionTypes"

export const getEvents = params => ({
  type: GET_EVENTS,
  payload: { params },
})

export const getEventsSuccess = experiences => ({
  type: GET_EVENTS_SUCCESS,
  payload: experiences,
})

export const resetExperiences = () => ({
  type: RESET_EVENTS,
  payload: {},
})

export const getEventsFailed = error => ({
  type: GET_EVENTS_FAILED,
  payload: error,
})

export const showLoadingIndicator = () => ({
  type: SHOW_LOADING_INDICATOR,
  payload: {},
})

export const hideLoadingIndicator = () => ({
  type: HIDE_LOADING_INDICATOR,
  payload: {},
})

export const changeEventPublishField = params => ({
  type: CHANGE_EVENT_PUBLISH_FIELD,
  payload: params ,
})

export const changeEventPublishFieldSuccess = response => ({
  type: CHANGE_EVENT_PUBLISH_FIELD_SUCCESS,
  payload: response,
})

export const changeEventPublishFieldFailed = error => ({
  type: CHANGE_EVENT_PUBLISH_FIELD_FAILED,
  payload: error,
})

export const selectEvent = (experience, isSelected) => ({
  type: SELECT_SINGLE_EVENT,
  payload: { experience, isSelected },
})

export const selectAllEvents = isSelected => ({
  type: SELECT_ALL_EVENTS,
  payload: { isSelected },
})

export const resetEventsSelection = () => ({
  type: RESET_EVENTS_SELECTION,
  payload: {},
})

export const setEventsSortOptions = sortOption => ({
  type: SET_EVENTS_SORT_OPTIONS,
  payload: { sortOption },
})

export const updateCategorizedEventsOrder = params => ({
  type: UPDATE_CATEGORIZED_EVENT_ORDER,
  payload: { params },
})

export const updateCategorizedEventsOrderSuccess = () => ({
  type: UPDATE_CATEGORIZED_EVENT_ORDER_SUCCESS,
  payload: {},
})

export const updateCategorizedEventsOrderFailed = error => ({
  type: UPDATE_CATEGORIZED_EVENT_ORDER_FAILED,
  payload: error,
})

export const updateEventOrder = params => ({
  type: UPDATE_EVENT_ORDER,
  payload: { params },
})

export const updateEventOrderSuccess = () => ({
  type: UPDATE_EVENT_ORDER_SUCCESS,
  payload: {},
})

export const updateEventOrderFailed = error => ({
  type: UPDATE_EVENT_ORDER_FAILED,
  payload: error,
})

export const updateBulkPublishStatus = params => ({
  type: UPDATE_BULK_PUBLISH_STATUS,
  payload: params,
})

export const updateBulkPublishStatusSuccess = response => ({
  type: UPDATE_BULK_PUBLISH_STATUS_SUCCESS,
  payload: response,
})

export const updateBulkPublishStatusFailed = error => ({
  type: UPDATE_BULK_PUBLISH_STATUS_FAILED,
  payload: error,
})

export const openExperiencesErrorModal = params => ({
  type: OPEN_EXPERIENCES_ERROR_MODAL,
  payload: params,
})

export const hideExperiencesErrorModal = () => ({
  type: HIDE_EXPERIENCES_ERROR_MODAL,
  payload: {},
})

export const openPublishNotificationModal = () => ({
  type: OPEN_PUBLISH_NOTIFICATION_MODAL,
  payload: {},
})

export const hidePublishNotificationModal = () => ({
  type: HIDE_PUBLISH_NOTIFICATION_MODAL,
  payload: {},
})

export const hideDeleteEventModal = () => ({
  type: HIDE_DELETE_EVENT_MODAL,
  payload: {},
})

export const openDeleteEventModal = () => ({
  type: OPEN_DELETE_EVENT_MODAL,
  payload: {},
})

export const handleDeleteEvent = event => ({
  type: HANDLE_DELETE_EVENT,
  payload: event,
})

export const handleDeleteEventSuccess = event => ({
  type: HANDLE_DELETE_EVENT_SUCCESS,
  payload: event,
})

export const handleDeleteEventFailed = error => ({
  type: HANDLE_DELETE_EVENT_FAILED,
  payload: error,
})

export const openEventBulkDeleteModal = () => ({
  type: OPEN_EVENT_BULK_DELETE_MODAL,
  payload: {},
})

export const hideEventBulkDeleteModal = () => ({
  type: HIDE_EVENT_BULK_DELETE_MODAL,
  payload: {},
})

export const handleEventBulkDelete = events => ({
  type: HANDLE_EVENT_BULK_DELETE,
  payload: events,
})

export const handleEventBulkDeleteSuccess = events => ({
  type: HANDLE_EVENT_BULK_DELETE_SUCCESS,
  payload: events,
})

export const handleEventBulkDeleteFailed = error => ({
  type: HANDLE_EVENT_BULK_DELETE_FAILED,
  payload: error,
})

export const addNewExperience = params => {
  if (params?.experience?.timezone === "Asia/Calcutta") {
    params = {
      ...params,
      experience: {
        ...params.experience,
        timezone: "Asia/Kolkata",
      },
    }
  }
  return {
    type: ADD_NEW_EXPERIENCE,
    payload: params,
  }
}

export const addNewExperienceSuccess = response => ({
  type: ADD_NEW_EXPERIENCE_SUCCESS,
  payload: response,
})

export const addNewExperienceFailed = error => ({
  type: ADD_NEW_EXPERIENCE_FAILED,
  payload: error,
})

export const getSelectedEvent = eventId => ({
  type: GET_SELECTED_EVENT,
  payload: eventId,
})

export const getSelectedEventSuccess = event => ({
  type: GET_SELECTED_EVENT_SUCCESS,
  payload: event,
})

export const getSelectedEventFailed = error => ({
  type: GET_SELECTED_EVENT_FAILED,
  payload: error,
})

export const resetSelectedEvent = () => ({
  type: RESET_SELECTED_EVENT,
  payload: {},
})

export const getEventInviteList = (vendorId, eventId, sortOptions) => ({
  type: GET_EVENT_INVITE_LIST,
  payload: { vendorId, eventId, sortOptions },
})

export const getEventInviteListSuccess = response => ({
  type: GET_EVENT_INVITE_LIST_SUCCESS,
  payload: response,
})

export const getEventInviteListFailed = error => ({
  type: GET_EVENT_INVITE_LIST_FAILED,
  payload: error,
})

export const sendInvites = (params, sortOptions, vendorId, eventId) => ({
  type: SEND_INVITES,
  payload: { params, sortOptions, vendorId, eventId },
})

export const sendInvitesSuccess = response => ({
  type: SEND_INVITES_SUCCESS,
  payload: response,
})

export const sendInvitesFailed = error => ({
  type: SEND_INVITES_FAILED,
  payload: error,
})

export const resetEventInviteList = () => ({
  type: RESET_EVENT_INVITE_LIST,
  payload: {},
})

export const deleteInvite = values => ({
  type: DELETE_INVITE,
  payload: values,
})

export const deleteInviteSuccess = response => ({
  type: DELETE_INVITE_SUCCESS,
  payload: response,
})

export const deleteInviteFailed = error => ({
  type: DELETE_INVITE_FAILED,
  payload: error,
})

export const addAccessCode = (postImageParams, event_id) => ({
  type: ADD_ACCESS_CODE,
  payload: { postImageParams, event_id },
})

export const postImageAccessCode = params => ({
  type: POST_IMAGE_ACCESS_CODE,
  payload: params,
})

export const addAccessCodeSuccess = params => ({
  type: ADD_ACCESS_CODE_SUCCESS,
  payload: params,
})

export const addAccessCodeFailed = error => ({
  type: ADD_ACCESS_CODE_FAILED,
  payload: error,
})

export const addAccessTag = (params, sortOptions) => ({
  type: ADD_ACCESS_TAG,
  payload: { params, sortOptions },
})

export const addAccessTagSuccess = () => ({
  type: ADD_ACCESS_TAG_SUCCESS,
  payload: {},
})

export const addAccessTagFailed = error => ({
  type: ADD_ACCESS_TAG_FAILED,
  payload: error,
})

export const openSavingModal = () => ({
  type: OPEN_SAVING_MODAL,
  payload: {},
})

export const hideSavingModal = () => ({
  type: HIDE_SAVING_MODAL,
  payload: {},
})

export const setEventInviteListSortOptions = sortOptions => ({
  type: SET_EVENT_INVITE_LIST_SORT_OPTIONS,
  payload: sortOptions,
})

export const editAttendee = params => ({
  type: EDIT_ATTENDEE,
  payload: params,
})

export const editAttendeeSuccess = response => ({
  type: EDIT_ATTENDEE_SUCCESS,
  payload: response,
})

export const editAttendeeFailed = error => ({
  type: EDIT_ATTENDEE_FAILED,
  payload: error,
})

export const sendAppInvites = params => ({
  type: SEND_APP_INVITES,
  payload: params,
})

export const sendAppInvitesSuccess = () => ({
  type: SEND_APP_INVITES_SUCCESS,
  payload: {},
})

export const sendAppInvitesFailed = error => ({
  type: SEND_APP_INVITES_FAILED,
  payload: error,
})

export const updateRsvp = (
  eventId,
  vendorId,
  rsvp,
  eventInviteListSortOptions
) => ({
  type: UPDATE_RSVP,
  payload: { eventId, vendorId, rsvp, eventInviteListSortOptions },
})

export const updateRsvpSuccess = response => ({
  type: UPDATE_RSVP_SUCCESS,
  payload: response,
})

export const updateRsvpFailed = error => ({
  type: UPDATE_RSVP_FAILED,
  payload: error,
})

export const openInactiveEventWarningModal = () => ({
  type: OPEN_INACTIVE_EVENT_WARNING_MODAL,
  payload: {},
})

export const hideInactiveEventWarningModal = () => ({
  type: HIDE_INACTIVE_EVENT_WARNING_MODAL,
  payload: {},
})

export const editAttendeeAndRsvp = (eventId, rsvp, attendee) => ({
  type: EDIT_ATTENDEE_AND_RSVP,
  payload: { eventId, rsvp, attendee },
})

export const editAttendeeAndRsvpSuccess = response => ({
  type: EDIT_ATTENDEE_AND_RSVP_SUCCESS,
  payload: response,
})

export const editAttendeeAndRsvpFailed = error => ({
  type: EDIT_ATTENDEE_AND_RSVP_FAILED,
  payload: error,
})

export const deleteRsvp = params => ({
  type: DELETE_RSVP,
  payload: params,
})

export const deleteRsvpSuccess = response => ({
  type: DELETE_RSVP_SUCCESS,
  payload: response,
})

export const deleteRsvpFailed = error => ({
  type: DELETE_RSVP_FAILED,
  payload: error,
})

export const updateEventAccessType = params => ({
  type: UPDATE_EVENT_ACCESS_TYPE,
  payload: params,
})

export const updateEventAccessTypeSuccess = response => ({
  type: UPDATE_EVENT_ACCESS_TYPE_SUCCESS,
  payload: response,
})

export const updateEventAccessTypeFailed = error => ({
  type: UPDATE_EVENT_ACCESS_TYPE_FAILED,
  payload: error,
})

export const getEventMenuList = params => ({
  type: GET_EVENT_MENU_LIST,
  payload: { params },
})

export const getEventMenuListSuccess = response => ({
  type: GET_EVENT_MENU_LIST_SUCCESS,
  payload: response,
})

export const getEventMenuListFailed = error => ({
  type: GET_EVENT_MENU_LIST_FAILED,
  payload: error,
})

export const updateEventMenuFeaturesOrder = (params, eventId) => ({
  type: UPDATE_EVENT_MENU_FEATURES_ORDER,
  payload: { params, eventId },
})

export const updateEventMenuFeaturesOrderSuccess = response => ({
  type: UPDATE_EVENT_MENU_FEATURES_ORDER_SUCCESS,
  payload: response,
})

export const updateEventMenuFeaturesOrderFailed = error => ({
  type: UPDATE_EVENT_MENU_FEATURES_ORDER_FAILED,
  payload: error,
})

export const updateExperience = params => ({
  type: UPDATE_EXPERIENCE,
  payload: params,
})

export const updateExperienceSuccess = response => ({
  type: UPDATE_EXPERIENCE_SUCCESS,
  payload: response,
})

export const updateExperienceFailed = error => ({
  type: UPDATE_EXPERIENCE_FAILED,
  payload: error,
})

export const getEventAccessCodes = params => ({
  type: GET_EVENT_ACCESS_CODES,
  payload: params,
})

export const getEventAccessCodesSuccess = response => ({
  type: GET_EVENT_ACCESS_CODES_SUCCESS,
  payload: response,
})

export const getEventAccessCodesFailed = error => ({
  type: GET_EVENT_ACCESS_CODES_FAILED,
  payload: error,
})

export const getInitialAccessTags = params => ({
  type: GET_INITIAL_ACCESS_TAGS,
  payload: params,
})

export const getInitialAccessTagsSuccess = response => ({
  type: GET_INITIAL_ACCESS_TAGS_SUCCESS,
  payload: response,
})

export const getInitialAccessTagsFailed = error => ({
  type: GET_INITIAL_ACCESS_TAGS_FAILED,
  payload: error,
})

export const joinEvent = params => ({
  type: JOIN_EVENT,
  payload: params,
})

export const joinEventSuccess = response => ({
  type: JOIN_EVENT_SUCCESS,
  payload: response,
})

export const joinEventFailed = error => ({
  type: JOIN_EVENT_FAILED,
  payload: error,
})

export const assignEventToCategory = params => ({
  type: ASSIGN_EVENT_TO_CATEGORY,
  payload: params,
})

export const getEventCategories = params => ({
  type: GET_EVENT_CATEGORIES,
  payload: params,
})

export const getEventCategoriesSuccess = response => ({
  type: GET_EVENT_CATEGORIES_SUCCESS,
  payload: response,
})

export const getEventCategoriesFailed = error => ({
  type: GET_EVENT_CATEGORIES_FAILED,
  payload: error,
})

export const getEventCodes = params => ({
  type: GET_EVENT_CODES,
  payload: params,
})

export const getEventCodesSuccess = response => ({
  type: GET_EVENT_CODES_SUCCESS,
  payload: response,
})

export const getEventCodesFailed = error => ({
  type: GET_EVENT_CODES_FAILED,
  payload: error,
})

export const sendEmailInvite = params => ({
  type: SEND_EMAIL_INVITE,
  payload: params,
})

export const sendEmailInviteSuccess = response => ({
  type: SEND_EMAIL_INVITE_SUCCESS,
  payload: response,
})

export const sendEmailInviteFailed = error => ({
  type: SEND_EMAIL_INVITE_FAILED,
  payload: error,
})

export const getEventDeepLinkUrl = params => ({
  type: GET_EVENT_DEEPLINK_URL,
  payload: params,
})

export const getEventDeepLinkUrlSuccess = response => ({
  type: GET_EVENT_DEEPLINK_URL_SUCCESS,
  payload: response,
})

export const getEventDeepLinkUrlFailed = error => ({
  type: GET_EVENT_DEEPLINK_URL_FAILED,
  payload: error,
})

export const getEventDeepLinkCodes = params => ({
  type: GET_EVENT_DEEPLINK_CODES,
  payload: params,
})

export const getEventDeepLinkCodesSuccess = response => ({
  type: GET_EVENT_DEEPLINK_CODES_SUCCESS,
  payload: response,
})

export const getEventDeepLinkCodesFailed = error => ({
  type: GET_EVENT_DEEPLINK_CODES_FAILED,
  payload: error,
})

export const generateDeepLinkCodes = params => ({
  type: GENERATE_DEEPLINK_CODES,
  payload: params,
})

export const generateDeepLinkCodesSuccess = response => ({
  type: GENERATE_DEEPLINK_CODES_SUCCESS,
  payload: response,
})

export const generateDeepLinkCodesFailed = error => ({
  type: GENERATE_DEEPLINK_CODES_FAILED,
  payload: error,
})

export const openGenerateDeeplinkModal = () => ({
  type: OPEN_GENERATE_DEEPLINK_MODAL,
  payload: {},
})

export const hideGenerateDeeplinkModal = () => ({
  type: HIDE_GENERATE_DEEPLINK_MODAL,
  payload: {},
})

export const openExpCloneConfirmationModal = () => ({
  type: OPEN_EXP_CLONE_CONFIRMATION_MODAL,
  payload: {},
})

export const hideExpCloneConfirmationModal = () => ({
  type: HIDE_EXP_CLONE_CONFIRMATION_MODAL,
  payload: {},
})

export const cloneExperience = params => ({
  type: CLONE_EXPERIENCE,
  payload: params,
})

export const cloneExperienceSuccess = response => ({
  type: CLONE_EXPERIENCE_SUCCESS,
  payload: response,
})

export const cloneExperienceFailed = error => ({
  type: CLONE_EXPERIENCE_FAILED,
  payload: error,
})
